const LogoConfluence = ({ size = 64 }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 63.78875 63.83"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <defs>
        <linearGradient
          id="linear-gradient-confluence"
          x1="59.68"
          y1="67.65"
          x2="20.35"
          y2="45.05"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.18" stopColor="#0052cc" />
          <stop offset="1" stopColor="#2684ff" />
        </linearGradient>
        <linearGradient
          id="linear-gradient-2-confluence"
          x1="279.76"
          y1="-1616.34"
          x2="240.42"
          y2="-1638.95"
          gradientTransform="translate(282.83 -1616.71) rotate(180)"
          xlinkHref="#linear-gradient-confluence"
        />
      </defs>
      <g id="Layer_2" data-name="Layer 2">
        <g id="Blue">
          <path
            fill="url(#linear-gradient-confluence)"
            d="M2.23,49.53c-.65,1.06-1.38,2.29-2,3.27a2,2,0,0,0,.67,2.72l13,8a2,2,0,0,0,2.77-.68c.52-.87,1.19-2,1.92-3.21,5.15-8.5,10.33-7.46,19.67-3l12.89,6.13a2,2,0,0,0,2.69-1l6.19-14a2,2,0,0,0-1-2.62c-2.72-1.28-8.13-3.83-13-6.18C28.51,30.45,13.62,31,2.23,49.53Z"
          />
          <path
            fill="url(#linear-gradient-2-confluence)"
            d="M60.52,17.76c.65-1.06,1.38-2.29,2-3.27a2,2,0,0,0-.67-2.72l-13-8A2,2,0,0,0,46,4.43c-.52.87-1.19,2-1.92,3.21-5.15,8.5-10.33,7.46-19.67,3L11.56,4.54a2,2,0,0,0-2.69,1l-6.19,14a2,2,0,0,0,1,2.62c2.72,1.28,8.13,3.83,13,6.18C34.24,36.84,49.13,36.27,60.52,17.76Z"
          />
        </g>
      </g>
    </svg>
  );
};

export default LogoConfluence;

